import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "../components/ui/accordion";
import { TECHNOLOGIES } from "../mock";
import { useContent } from "../context/ContentContext";

export default function Resources() {
  const { c } = useContent();
  const r = c.resources;
  const faqs = c.faqs || [];
  return (
    <main>
      <section className="bg-[var(--navy)] py-16 lg:py-24">
        <div className="mx-auto max-w-[1200px] px-5 lg:px-8">
          <p className="text-[12px] font-bold uppercase tracking-[0.14em] text-[#5aa0e0]">{r.heroEyebrow}</p>
          <h1 className="font-display mt-3 text-[38px] font-extrabold leading-tight tracking-tight text-white sm:text-[48px]">{r.heroTitle}</h1>
          <p className="mt-4 max-w-2xl text-[17px] leading-relaxed text-slate-300">{r.heroSubtitle}</p>
        </div>
      </section>

      <section className="bg-[#f7f8fa] py-16 lg:py-20">
        <div className="mx-auto max-w-[1200px] px-5 lg:px-8">
          <p className="eyebrow">{r.evalEyebrow}</p>
          <h2 className="font-display mt-3 text-[30px] font-extrabold tracking-tight text-[var(--ink)] sm:text-[38px]">{r.evalTitle}</h2>
          <p className="mt-4 max-w-3xl text-[16px] leading-relaxed text-slate-500">{r.evalDescription}</p>
          <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-2">
            {TECHNOLOGIES.map((t) => (
              <div key={t.n} className="rounded-2xl border border-slate-200 bg-white p-7">
                <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-[var(--navy)] font-display text-[18px] font-extrabold text-white">{t.n}</div>
                <h3 className="font-display mt-5 text-[20px] font-bold text-[var(--ink)]">{t.title}</h3>
                <p className="mt-1 text-[14px] font-semibold text-[var(--brand-blue)]">{t.sub}</p>
                <p className="mt-3 text-[15px] leading-relaxed text-slate-500">{t.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-white py-16 lg:py-20">
        <div className="mx-auto max-w-[860px] px-5 lg:px-8">
          <div className="text-center">
            <p className="eyebrow">FAQ</p>
            <h2 className="font-display mt-3 text-[30px] font-extrabold tracking-tight text-[var(--ink)] sm:text-[38px]">{r.faqTitle}</h2>
          </div>
          <Accordion type="single" collapsible className="mt-10 w-full">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`r-${i}`} className="border-b border-slate-200">
                <AccordionTrigger className="py-5 text-left text-[16px] font-semibold text-[var(--ink)] hover:no-underline">{f.q}</AccordionTrigger>
                <AccordionContent className="pb-5 text-[15px] leading-relaxed text-slate-500">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </main>
  );
}
